document.documentElement.classList.remove('no-js');

(() => {
  const moneyText = (option, key) => option ? option.dataset[key] || '' : '';

  function initHeader(root = document) {
    root.querySelectorAll('[data-menu-toggle]').forEach((button) => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const header = button.closest('[data-site-header]');
        const isOpen = header.classList.toggle('menu-open');
        document.body.classList.toggle('menu-open', isOpen);
        button.setAttribute('aria-expanded', String(isOpen));
      });
    });
    root.querySelectorAll('.site-nav__link').forEach((link) => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', () => {
        const header = link.closest('[data-site-header]');
        header?.classList.remove('menu-open');
        document.body.classList.remove('menu-open');
        header?.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initProduct(root = document) {
    root.querySelectorAll('[data-product-root]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';

      const slides = [...section.querySelectorAll('[data-media-slide]')];
      const thumbs = [...section.querySelectorAll('[data-media-thumb]')];
      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

      const showMedia = (index) => {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          slide.setAttribute('aria-hidden', String(i !== current));
        });
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === current);
          thumb.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showMedia(index)));
      section.querySelector('[data-media-prev]')?.addEventListener('click', () => showMedia(current - 1));
      section.querySelector('[data-media-next]')?.addEventListener('click', () => showMedia(current + 1));

      const quantity = section.querySelector('[data-quantity-input]');
      section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      });
      section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
      });

      const variant = section.querySelector('[data-variant-select]');
      variant?.addEventListener('change', () => {
        const option = variant.selectedOptions[0];
        const price = section.querySelector('[data-product-price]');
        const compare = section.querySelector('[data-product-compare]');
        const add = section.querySelector('[data-add-button]');
        const stock = section.querySelector('[data-stock]');
        const available = option?.dataset.available === 'true';
        if (price) price.textContent = moneyText(option, 'price');
        if (compare) {
          compare.textContent = moneyText(option, 'compare');
          compare.hidden = !compare.textContent;
        }
        if (add) {
          add.disabled = !available;
          add.querySelector('span').textContent = available ? add.dataset.availableText : add.dataset.soldText;
        }
        if (stock) {
          stock.classList.toggle('is-out', !available);
          stock.querySelector('strong').textContent = available ? stock.dataset.inText : stock.dataset.outText;
        }
        const mediaId = option?.dataset.mediaId;
        if (mediaId) {
          const mediaIndex = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
          if (mediaIndex >= 0) showMedia(mediaIndex);
        }
      });
    });
  }

  function initAll(root = document) {
    initHeader(root);
    initProduct(root);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
